export type SyncEventType = "login" | "logout" | "token_refresh"
export type SyncHandler = (event: SyncEventType) => void

export class AuthSync {
  private channel: BroadcastChannel | null = null
  private handler: SyncHandler
  private storageListener: ((e: StorageEvent) => void) | null = null
  private channelName: string

  constructor(channelName: string, handler: SyncHandler) {
    this.channelName = channelName
    this.handler = handler

    if (typeof window === "undefined") return

    if (typeof BroadcastChannel !== "undefined") {
      this.channel = new BroadcastChannel(channelName)
      this.channel.onmessage = (e: MessageEvent) => {
        if (e.data && typeof e.data.type === "string") {
          this.handler(e.data.type as SyncEventType)
        }
      }
    } else {
      this.storageListener = (e: StorageEvent) => {
        if (e.key === `__sync_${channelName}` && e.newValue) {
          try {
            const data = JSON.parse(e.newValue)
            if (data && typeof data.type === "string") {
              this.handler(data.type as SyncEventType)
            }
          } catch {
            // Ignore malformed events
          }
        }
      }
      window.addEventListener("storage", this.storageListener)
    }
  }

  emit(type: SyncEventType): void {
    if (typeof window === "undefined") return

    if (this.channel) {
      this.channel.postMessage({ type })
    } else {
      try {
        const key = `__sync_${this.channelName}`
        localStorage.setItem(key, JSON.stringify({ type, t: Date.now() }))
        localStorage.removeItem(key)
      } catch {
        // localStorage unavailable
      }
    }
  }

  destroy(): void {
    if (this.channel) {
      this.channel.close()
      this.channel = null
    }
    if (this.storageListener && typeof window !== "undefined") {
      window.removeEventListener("storage", this.storageListener)
      this.storageListener = null
    }
  }
}
